<!--
 * @Author: 张天昊
 * @Date: 2024-05-21 17:39:12
 * @LastEditTime: 2024-06-04 14:28:24
 * @LastEditors: 张天昊
 * @Description: 带标题的块
 * @FilePath: /Mobile/src/pages/itineraryUniversal/components/BlockWithTitle.vue
-->
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    title: {
      type: String,
      required: true
    }
  }
});
</script>

<template>
  <div>
    <h3 class="mb-12 text-16 leading-22 font-semibold">{{ title }}</h3>
    <slot />
  </div>
</template>
